/**
 * Frontend mirror of `src/fuel_analysis/web/cars_constants.py`.
 *
 * Keep in sync manually. The backend remains source-of-truth for
 * validation; these tables are used only to build sane <select> options.
 */

import type { CarIconName, FuelCategory } from "../../api/types";

export const CAR_ICONS: { name: CarIconName; label: string }[] = [
  { name: "sedan", label: "Sedan" },
  { name: "wagon", label: "Wagon" },
  { name: "camper", label: "Camper" },
  { name: "pickup", label: "Pickup" },
  { name: "motorcycle", label: "Motorcycle" },
];

export const FUEL_CATEGORIES: { value: FuelCategory; label: string }[] = [
  { value: "diesel", label: "Diesel" },
  { value: "gasoline", label: "Gasoline" },
  { value: "lpg", label: "LPG" },
  { value: "gasoline_lpg_hybrid", label: "Gasoline + LPG" },
];

export const FUEL_TYPES_BY_CATEGORY: Record<FuelCategory, string[]> = {
  diesel: ["diesel", "premium_diesel"],
  gasoline: ["super_e5", "super_e10", "super_plus_98", "super_plus_e5_98"],
  lpg: ["lpg"],
  gasoline_lpg_hybrid: [
    "super_e5",
    "super_e10",
    "super_plus_98",
    "super_plus_e5_98",
    "lpg",
  ],
};

export const DEFAULT_FUEL_TYPE_BY_CATEGORY: Record<FuelCategory, string> = {
  diesel: "diesel",
  gasoline: "super_e10",
  lpg: "lpg",
  gasoline_lpg_hybrid: "super_e10",
};

const FUEL_TYPE_LABELS: Record<string, string> = {
  diesel: "Diesel",
  premium_diesel: "Premium diesel",
  super_e5: "Super E5",
  super_e10: "Super E10",
  super_plus_98: "Super Plus (98)",
  super_plus_e5_98: "Super Plus E5 (98)",
  lpg: "LPG",
};

export function fuelTypeLabel(value: string): string {
  return FUEL_TYPE_LABELS[value] ?? value;
}
